export default function printReportNotes(type, status, startDate, endDate) {
  const token = localStorage.getItem("token");
  printNotes(token, type, status, startDate, endDate)

}

function printNotes(token, type, status, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/nota/print/report/all/notes/or/per/model/?auth=${token}&type=${type}&status=${status}&startDate=${startDate}&endDate=${endDate}`
  );
}
